import createReducer from '../createReducer';

const initialState = {
    pixel:{
        customPixels:[],
        specialPixels:[],
    },
    lead:{
        leads:[],
        automatedLeads:[],
        getLeadsXHR:null,
        getAutomatedLeadsXHR:null,
        queryFilter: {},
        freeFilter: '',
        status: '',
        leadRecipients: 0,
        getLeadRecipientsXHR: null
    },
    getPixelsXHR:null,
    
    updateSpecialPixelXHR:null,
    addSpecialPixelXHR:null
};

const reducer = createReducer('publish',initialState);

export default reducer;